import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';

export type SlotRankHistoryMap = { [date: string]: number | null };

function normalizeRankHistory(raw: any): SlotRankHistoryMap {
  if (!raw) return {};
  // API가 { rank_history: ... } 형태로 감싸서 주는 경우도 지원
  const payload = raw?.rank_history ?? raw;

  if (Array.isArray(payload)) {
    const result: SlotRankHistoryMap = {};
    for (const item of payload) {
      const date = item?.date ?? item?.dt ?? item?.day ?? undefined;
      const rank = item?.rank ?? item?.value ?? item?.r ?? null;
      if (!date) continue;
      const parsed = rank === null || rank === undefined
        ? null
        : typeof rank === 'number'
          ? rank
          : (Number.isNaN(Number(rank)) ? null : Number(rank));
      const key = String(date);
      const existing = result[key];
      // 같은 날짜에 숫자 순위와 Adlog placeholder가 같이 있으면 숫자를 유지
      if (existing !== undefined && existing !== null && parsed === null) {
        continue;
      }
      result[key] = parsed;
    }
    return result;
  }

  if (payload && typeof payload === 'object') {
    const obj = payload as Record<string, any>;
    const result: SlotRankHistoryMap = {};
    for (const [k, v] of Object.entries(obj)) {
      const parsed = v === null || v === undefined
        ? null
        : typeof v === 'number'
          ? v
          : (Number.isNaN(Number(v)) ? null : Number(v));
      result[String(k)] = parsed;
    }
    return result;
  }

  return {};
}

export class GetSlotRankHistoryUseCase {
  constructor(private repo: SlotRepository) {}

  async execute(current: User | null, slotId: number): Promise<SlotRankHistoryMap> {
    if (!current) throw new Error('로그인이 필요합니다.');
    const raw = await this.repo.getSlotRankHistory(slotId);
    return normalizeRankHistory(raw);
  }
}







